import React from 'react';
import { useFormState } from 'react-final-form';
import { NIL } from 'uuid';
import SelectInputControl from './SelectInput';
import TextInputControl from './TextInput';
import useProjects from '../../hooks/useProjects';
import useContact from '../../hooks/useContact';
import { CustomerStaffMember } from '../../models/contactInfo';
import { Project } from '../../models/project';

// item 833/C1 (Chad) — "Requested By" renamed to "Project Manager" and turned into a dropdown of the
// customer's CRM staff (same roster the salesperson picker uses). Stores the staff NAME on the
// existing `requestedBy` field, so it's backward-compatible with saved free-text and needs no schema
// change. Free-text fallback when the customer has no staff yet. Shared by the proposal, work order,
// and sales order forms.
const ProjectManagerField: React.FC<{ isRequired?: boolean }> = ({ isRequired = false }) => {
  const { values } = useFormState({ subscription: { values: true } });
  const v = values as { customerId?: string; projectId?: string };
  const { data: projects } = useProjects();
  const projectCustomerId = (projects?.index ?? []).find((p: Project) => p.id === v.projectId)?.customerId;
  const customerId = v.customerId || projectCustomerId || '';
  const { data: customer } = useContact({ id: customerId || NIL });
  const staff: CustomerStaffMember[] = customer?.staff ?? [];

  if (staff.length > 0) {
    return (
      <SelectInputControl name="requestedBy" label="Project Manager" isRequired={isRequired}>
        <option value="">—</option>
        {staff.map((st) => (
          <option key={st.id} value={st.name}>{st.name}</option>
        ))}
      </SelectInputControl>
    );
  }
  return (
    <TextInputControl
      name="requestedBy"
      label="Project Manager"
      isRequired={isRequired}
      helperText="Add staff to this customer in the CRM to pick from a list."
    />
  );
};

ProjectManagerField.defaultProps = { isRequired: false };

export default ProjectManagerField;
